import {
  GET_ZIPSTATECODES
} from '../actions/types';

const INITIAL_STATE = {
  zipStateCodes: {}
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_ZIPSTATECODES:
      return {
        ...state,
        zipStateCodes: action.data
      };
    default:
      return state;
  }
};